import dynamic from 'next/dynamic';
import { RequestContactWizardProps } from './RequestContactWizard';

export const DynamicRequestContactWizard = dynamic<RequestContactWizardProps>(
    () => import('./RequestContactWizard').then(md => md.RequestContactWizard),
);
